$(document).ready(function() {

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * userMenu
    // *
    // *
    $(".js-usermenu-button").click(function(){
        $(".js-usermenu").fadeToggle().toggleClass("active");
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
	// * toggleContentButton
	// *
	// *
    if ($(".js-toggle-content-button").length) {
        $(".js-toggle-content-button").on("change", function() {
            var id = $(this).data("toggle-content-id"),
                type = $(this).data("toggle-content-type"),
                action = $(this).data("toggle-content-action"),
                reset = $(this).data("toggle-content-form-reset");

            if (type == 'select') {
                if (action == 'show') {
                    $("#" + id).slideDown();
                }else {
                    $("#" + id).slideUp();
                }
            }else {
                if ($(this).prop("checked")) {
                    $("#" + id).slideUp();
                }else {
                    $("#" + id).slideDown();
                }
            }

            // reset all forms
            if (reset == true) {
                $("#" + id).find("input").prop('checked', false);
            }

        });

        $(".js-toggle-content-button:checked").trigger('change');
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * ie11 Fix SVG + opbject fit
    // *
    // *
    svg4everybody();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * quantity cart
    // *
    // *
    $(".js-quantity-button").click(function(){
        var $parent = $(this).parents(".js-quantity"),
            $input = $parent.find(".js-quantity-input"),
            value = parseInt($input.val());

        if ($(this).data("type") == 'minus') {
            value--;
            if (value <= 0) value = 0;
        }

        if ($(this).data("type") == 'plus') {
            value++;
        }

        $input.val(value);
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('.js-targetblankwrapper a:not([data-targetblank=ignore])').each(function() {
        if(location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        }else {
            $(this).attr('target','_blank');
        }
    });

});
